// Base stylesheet needed for every page
import './scss/app.scss';

require('./scripts/adp');
require('./scripts/cart');
require('./scripts/customer');
require('./scripts/filters');
require('./scripts/footer');
require('./scripts/navigation');
require('./scripts/product');
require('./scripts/product-recommendations');
require('./scripts/productBlock');
require('./scripts/productPopup');
require('./scripts/productGallery');
require('./scripts/productCallback');
require('./scripts/productStock');
require('./scripts/quantity');
require('./scripts/slider');
require('./scripts/readmore');
require('./scripts/recently-viewed');
require('./scripts/wishlist');
